import React, { useEffect } from 'react';
import { useSidebarContext } from '../../context/sidebarContext';
import { Link } from 'gatsby';
import config from '../../../config';

const Breadcrumb = ({ location }) => {
  const { urlObject } = useSidebarContext();
  const [breadcrumbs, setBreadcrumb] = React.useState(null);

  const generateBreadcrumb = (data) => {
    data.unshift({
      url: '/',
      title: 'Home',
    });
    const tempBreadcrumbs = data?.map((obj, index) => {
      const url = obj.url;
      const label = obj.title;
      return (
        <React.Fragment key={url}>
          {index !== data.length - 1 ? <Link to={url}>{label}</Link> : <span>{obj.title}</span>}
          {index < data.length - 1 && <span className="px-1"> / </span>}
        </React.Fragment>
      );
    });
    setBreadcrumb(tempBreadcrumbs);
  };

  function findItemHierarchy(items, selectedLabel) {
    const sortedArr = [];
    for (const item of items) {
      // if (selectedLabel.startsWith(item.url)) {
      if (
        selectedLabel.startsWith(item.url) ||
        selectedLabel.startsWith(config.gatsby.pathPrefix.slice(0, -1) + item.url)
      ) {
        sortedArr.push(item);
      }
    }
    sortedArr.sort((a, b) => a.url.length - b.url.length);
    generateBreadcrumb(sortedArr);
  }

  function flatten(arr) {
    return arr.reduce((acc, curr) => {
      // Push the current object into the accumulator array
      acc.push(curr);
      // If the current object has a 'children' property which is an array, recursively flatten it
      if (curr.items) {
        acc.push(...flatten(curr.items));
      }
      return acc;
    }, []);
  }
  const highlightedNoteTag = () => {
    // Get all <p> elements with class 'paragraph'
    const paragraphs = document.querySelectorAll('p.paragraph');

    // Loop through each paragraph element
    paragraphs.forEach((paragraph) => {
      // Find <strong> element within current paragraph
      const strongElement = paragraph.querySelector('strong');

      // Check if <strong> element contains 'Note:'
      if (strongElement && strongElement.textContent.includes('Note')) {
        // Apply styles to the paragraph
        paragraph.classList.add('customAlertPara', 'alert');
        strongElement.style.color = 'var(--charcoal)';
        // You can add more styles here as needed
      }
    });

    var olElement = document.querySelectorAll('ol');
    olElement.forEach((olEl) => {
      var startValue = olEl.getAttribute('start') || 1; // Default start value is 1
      // Reset the counter based on the start attribute
      olEl.style.counterReset = 'my-counter ' + (parseInt(startValue, 10) - 1);
    });
  };
  useEffect(() => {
    const pathnames = location.pathname;
    if (urlObject?.items) {
      const objects = flatten(urlObject.items);
      if (objects) {
        findItemHierarchy(objects, pathnames);
      }
    }
    highlightedNoteTag();
  }, [location.pathname, urlObject]);

  return <div className="mt-4 breadcrumb">{breadcrumbs}</div>;
};

export default Breadcrumb;
